import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import RefNoteComponent from '@/entities/briefing/reference/popup-add-reference/ref-note/refNote.vue';
import RefReferenceComponent from '@/entities/briefing/reference/popup-add-reference/ref-reference/refReference.vue';
import RefSearchComponent from '@/entities/briefing/reference/popup-add-reference/ref-search/refSearch.vue';
import RefUrlComponent from '@/entities/briefing/reference/popup-add-reference/ref-url/refUrl.vue';
import BriefingService from '@/service/briefing.service';
import { BriefingResourceRequest } from '@/shared/model/briefing-resource.model';
import axios from 'axios';
import RefFileComponent from '@/entities/briefing/reference/popup-add-reference/ref-file/refFile.vue';
import RefMyScrapComponent from '@/entities/briefing/reference/popup-add-reference/ref-my-scrap/refMyScrap.vue';
import {
  convertToBriefingReferenceItemRefactor,
  convertToBriefingResourceReq,
  mergeTwoArrayByRemoveAllDuplicatedItemByDocIdAndPath,
  removeAllDuplicatedNote,
} from '@/util/ds-util';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import { REFERENCE_TAB_SELECT } from '@/constants';

const appStoreState = namespace('appStore');
const briefingStoreState = namespace('briefingStore');

@Component({
  computed: {
    REFERENCE_TAB_SELECT() {
      return REFERENCE_TAB_SELECT;
    },
  },
  components: {
    refNodeComponent: RefNoteComponent,
    refReferenceComponent: RefReferenceComponent,
    refSearchComponent: RefSearchComponent,
    refUrl: RefUrlComponent,
    refFile: RefFileComponent,
    reMyScrap: RefMyScrapComponent,
  },
})
export default class PopupAddReference extends Vue {
  @appStoreState.Getter
  public isShowAddReference!: boolean;

  @briefingStoreState.Getter
  public getAddingReferenceDocuments!: Array<any> | [];

  @appStoreState.Mutation
  public setShowAddReference!: (isShowAddReference: boolean) => void;

  @briefingStoreState.Mutation
  public setAddingReferenceDocuments!: () => void;

  @briefingStoreState.Mutation
  public resetAddingReferenceDocuments!: () => void;

  @briefingStoreState.Mutation
  public setReferenceDocuments!: (payload: any) => void;

  @briefingStoreState.Getter
  getReferenceDocuments!: Array<any>;

  @briefingStoreState.Getter
  public isUpdateBriefing!: any;

  @briefingStoreState.Mutation
  public setIsUpdateBriefing!: (payload: any) => void;

  @briefingStoreState.Getter
  public getSelectedBriefingPage!: any;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @briefingStoreState.Mutation
  public addToReferentDocuments!: (payload: any) => void;

  @appStoreState.Mutation
  public setDisabledLink!: (payload: any) => void;

  @appStoreState.Getter
  public getIsShowEditReportRef!: boolean;

  @briefingStoreState.Getter
  public getSelectedResource!: IResourceModel;

  // @briefingStoreState.Getter
  // getReferenceDocumentsForReport!: Array<any>;

  @briefingStoreState.Mutation
  public setReferenceDocumentsForReport!: (payload: any) => void;

  @briefingStoreState.Getter
  public getSelectedReferenceTab!: string;

  @briefingStoreState.Mutation
  setSelectedReferenceTab!: (payload: string) => void;

  @appStoreState.Getter
  public getIsOpenPopupEditReferenceForPage!: boolean;

  @briefingStoreState.Mutation
  setStoreReferencesForEditByPage!: (payload: any[]) => void;

  @briefingStoreState.Getter
  public getReferenceDocumentsForNewBriefing!: any[];

  @briefingStoreState.Getter
  public getIsForNewBriefing!: boolean;

  @briefingStoreState.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @briefingStoreState.Mutation
  public setIsForNewBriefing!: (payload: boolean) => void;

  @briefingStoreState.Mutation
  public setIsCreateNewBriefingFromChat!: (IsCreateNewBriefingFromChat: boolean) => void;

  @appStoreState.Mutation
  public setShowCreateBriefing!: (isShowCreateBriefing: boolean) => void;

  @appStoreState.Getter
  public getCheckToMoveToAskSub!: boolean;

  @appStoreState.Mutation
  public setCheckToMoveToAskSub!: (checkToMoveToAskSub: boolean) => void;

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  isLoading = false;
  pollingIntervalCheckCrawData = 5000;
  // timeoutDurationCheckCrawData = 120000;
  timeoutDurationCheckCrawData = 60000;
  isLoadingCheckCrawData = false;
  isShowResultCheckCrawData = false;
  intervalWaitCrawData;
  documentsHaveContentList = [];
  isCancelCrawData = false;
  // idsListDocumentCheckCrawData = [];
  numberTotalDocumentsCheckCrawData = 0;
  timeoutShowResultCheckCrawData;

  mounted() {
    if (this.getSelectedReferenceTab) {
      const intervalClickToElement = setInterval(() => {
        const tempElement = document.getElementById(this.getSelectedReferenceTab);

        if (tempElement) {
          tempElement.click();
          this.setSelectedReferenceTab('');
          clearInterval(intervalClickToElement);
        }
      }, 100);

      setTimeout(() => {
        this.setSelectedReferenceTab('');
        clearInterval(intervalClickToElement);
      }, 5000);
    }
  }

  @Watch('$route')
  onRouteChange() {
    this.resetCheckCrawData();
    this.setShowAddReference(false);
    this.setShowCreateBriefing(false);
    this.setIsForNewBriefing(false);
    this.setReferenceDocumentsForNewBriefing([]);
  }

  handleConfirm() {
    const tempList = this.documentsHaveContentList || [];

    this.resetCheckCrawData();
    this.resetAddingReferenceDocuments();
    this.setIsUpdateBriefing(false);

    if (this.$route.name === 'Home' && tempList?.length > 0) {
      const listReferenceDocAdded = this.getReferenceDocuments.filter(doc => {
        // reset list reference tab when add references
        return doc.docId && tempList.includes(doc.docId);
      });
      this.setReferenceDocuments(listReferenceDocAdded);
      this.setCheckToMoveToAskSub(!this.getCheckToMoveToAskSub);
    }

    if (this.getIsForNewBriefing !== undefined && this.getIsForNewBriefing === true && tempList?.length > 0) {
      this.setIsCreateNewBriefingFromChat(false);
      this.setShowCreateBriefing(true);
    }

    this.setShowAddReference(false);
  }

  handleClosePopUp() {
    this.resetCheckCrawData();
    this.resetAddingReferenceDocuments();
    this.setIsUpdateBriefing(false);
    this.setIsCreateNewBriefingFromChat(false);
    this.setShowCreateBriefing(false);
    this.setShowAddReference(false);
  }

  async addToReferenceDocuments() {
    let documents: BriefingResourceRequest[] = [];
    const tempDocumentsFile = [];
    const tempRequestResourceListFile = [];
    const localFilesWithS3 = [];
    const driveFilesWithS3 = [];
    const fileFormData = new FormData();
    let saveFile = false;
    const userKey = this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
    const lastName = this.userIdentity?.lastName || JSON.parse(localStorage.getItem('localStorageUser'))?.lastName || '';
    const tempRequestId = Date.now().toString();
    const isForReportDetail = this.getIsShowEditReportRef && this.getSelectedResource && !this.getIsOpenPopupEditReferenceForPage;
    const isNotInsertBpId = this.getIsForNewBriefing !== undefined && this.getIsForNewBriefing === true ? true : undefined;

    if (!userKey) {
      this.$bvToast.toast(`${this.$t('toast.notAcceptUser')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('toast.title.error')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
    }

    const tempListMapForURL = [];
    let tempIndexFile = 0;

    this.getAddingReferenceDocuments.forEach(element => {
      if (element?.type) {
        if (element?.type === 'URL') {
          if (element.image_uri && element.image_uri.length > 0 && element.path) {
            tempListMapForURL.push({
              path: element.path || '',
              image_uri: element.image_uri || '',
              author: element.author || '',
              channel: element.channel || '',
              published_at: element.published_at || '',
            });
          }
        }

        if (element.type === 'FILE') {
          saveFile = true;
          element.path = 'FILE' + tempIndexFile;
          tempDocumentsFile.push({
            ...convertToBriefingResourceReq(
              element,
              userKey,
              this.$route.name,
              this.getSelectedBriefingPage,
              this.getAddingReferenceDocuments,
              this.$i18n.locale,
              lastName,
              tempRequestId,
              this.isUpdateBriefing || undefined,
              isNotInsertBpId
            ),
            document: element.document === 'drive' ? 'driveFiles' : 'localFiles',
            channel: element.channel ? element.channel : '',
          });
          fileFormData.append(element.document === 'drive' ? 'driveFiles' : 'localFiles', element.file);
          tempIndexFile += 1;
        }

        documents.push(
          convertToBriefingResourceReq(
            element,
            userKey,
            this.$route.name,
            this.getSelectedBriefingPage,
            this.getAddingReferenceDocuments,
            this.$i18n.locale,
            lastName,
            tempRequestId,
            this.isUpdateBriefing || undefined,
            isNotInsertBpId
          )
        );
      }
    });

    let requestedResourceList = this.getAddingReferenceDocuments.filter(item => item.docId).map(item => item.docId);
    if (this.isUpdateBriefing) {
      requestedResourceList.push(...this.getReferenceDocuments.map(item => item.docId));
    }

    if (this.getAddingReferenceDocuments.filter(item => !item.docId).length) {
      const documentsToGetId = this.getAddingReferenceDocuments.filter(item => !item.docId);
      await axios
        .post(
          `api/learning/learning-center/${userKey}/getDocId?lang=` + this.$i18n.locale || 'en',
          documentsToGetId.map(item =>
            convertToBriefingResourceReq(
              item,
              userKey,
              this.$route.name,
              this.getSelectedBriefingPage,
              this.getAddingReferenceDocuments,
              this.$i18n.locale,
              lastName,
              tempRequestId
            )
          )
        )
        .then(res => {
          // throw new Error();
          if (res?.data?.length) {
            documents = [
              ...documents.filter(document => document.parentDocId),
              ...res.data.map(item =>
                convertToBriefingResourceReq(
                  item,
                  userKey,
                  this.$route.name,
                  this.getSelectedBriefingPage,
                  this.getAddingReferenceDocuments,
                  this.$i18n.locale,
                  lastName,
                  tempRequestId,
                  this.isUpdateBriefing || undefined,
                  isNotInsertBpId
                )
              ),
            ];

            if (tempListMapForURL && tempListMapForURL.length > 0) {
              documents.forEach(document => {
                tempListMapForURL.forEach(urlItem => {
                  if (document.path === urlItem.path) {
                    document.image_uri = urlItem.image_uri;
                    document.writer = [urlItem.author];
                    document.channel = urlItem.channel;
                    document.published_at = urlItem.published_at;
                  }
                });
              });
            }

            if (saveFile && tempDocumentsFile && tempDocumentsFile.length > 0) {
              documents.forEach(document => {
                tempDocumentsFile.forEach(fileItem => {
                  if (document.path === fileItem.path) {
                    const tempId = document.parent_doc_id?.[0] || document.parentDocId || '';
                    tempRequestResourceListFile.push(tempId);
                    const tempTime = new Date().toISOString();

                    if (fileItem.document === 'driveFiles') {
                      driveFilesWithS3.push({ id: tempId, path: document.userKey + '_' + tempTime + '_' + document.title });
                    } else {
                      localFilesWithS3.push({ id: tempId, path: document.userKey + '_' + tempTime + '_' + document.title });
                    }
                    // document.path = '/opt/deepsignal/download/' + document.userKey + '/' + document.title;
                    document.path = document.userKey + '_' + tempTime + '_' + document.title;
                    document.channel = fileItem.channel ? fileItem.channel : '';
                  }
                });
              });
            }

            requestedResourceList = [...requestedResourceList, ...res.data.map(item => item.docId)];

            // remove duplicate
            requestedResourceList = requestedResourceList.filter((item, index) => requestedResourceList.indexOf(item) === index);
          } else {
            documents = documents.filter(document => document.parentDocId);
          }
        });
    }

    if (documents.length) {
      let tempDocuments = documents.map(({ channel, ...rest }) => rest);

      // if (this.$route.name === 'MyBriefing-Detail' && this.getSelectedBriefingPage?.bpId) {
      // if (this.$route.name === 'Home') {
      if (!isForReportDetail) {
        tempDocuments = removeAllDuplicatedNote(this.getReferenceDocuments, tempDocuments);
      }

      if (!tempDocuments || (tempDocuments && tempDocuments.length === 0)) {
        this.resetCheckCrawData();
        this.resetAddingReferenceDocuments();
        this.setShowAddReference(false);
        return;
      }

      // }

      this.$root.$emit('clear-scrap', false);

      await this.briefingService()
        .saveBriefingResource(
          tempDocuments.map(item => ({
            ...item,
            requestId: tempRequestId,
            requestedResourceList: requestedResourceList,
            // targetBpId: (this.$route.name === 'MyBriefing-Detail' && this.getSelectedBriefingPage?.bpId) || item.targetBpId,
            targetBpId: null,
          }))
        )
        .then(async res => {
          if (res?.status === 200 && res?.data?.body?.data) {
            let documentSaveSuccess = documents.filter(
              document => res.data.body?.data.map(data => data.parentDocId).indexOf(document.parentDocId) > -1
            );

            let lastIndex = this.getReferenceDocuments.length
              ? this.getReferenceDocuments[this.getReferenceDocuments.length - 1]?.referenceDocumentIndex
              : 0;

            await this.saveFileForDocumentConverter(
              saveFile,
              tempDocumentsFile,
              tempRequestId,
              tempRequestResourceListFile,
              userKey,
              localFilesWithS3,
              driveFilesWithS3,
              fileFormData
            )
              .then(async documentConverterResponse => {
                let tempIdDocumentsList = documentSaveSuccess.map(dssItem => dssItem.parentDocId);

                if (documentConverterResponse?.data.data && documentConverterResponse?.data?.data?.length > 0) {
                  const tempDocumentConverted = tempIdDocumentsList.filter(tIdItem =>
                    documentConverterResponse?.data?.data?.includes(tIdItem)
                  );

                  const filteredTempIdDocumentsList = tempIdDocumentsList.filter(
                    tIdItem =>
                      !tempDocumentsFile.some(tdf => tdf.parentDocId === tIdItem) &&
                      !documentConverterResponse?.data?.data?.includes(tIdItem)
                  );

                  tempIdDocumentsList = [...filteredTempIdDocumentsList, ...tempDocumentConverted];
                } else if (saveFile) {
                  tempIdDocumentsList = tempIdDocumentsList.filter(tIdItem => !tempDocumentsFile.some(tdf => tdf.parentDocId === tIdItem));
                }

                if (tempIdDocumentsList && tempIdDocumentsList.length > 0) {
                  this.numberTotalDocumentsCheckCrawData = tempIdDocumentsList?.length;

                  if (this.$route.name === 'MyBriefing-Detail' && this.getSelectedBriefingPage?.bpId) {
                    await this.waitCrawData(tempIdDocumentsList, true);
                  } else {
                    await this.waitCrawData(tempIdDocumentsList, false);
                  }
                } else {
                  this.numberTotalDocumentsCheckCrawData = 0;
                }

                if (this.isCancelCrawData === true) {
                  this.documentsHaveContentList = [];
                  return;
                }

                documentSaveSuccess = documentSaveSuccess.filter(doss => this.documentsHaveContentList.includes(doss.parentDocId));

                if (this.getIsForNewBriefing !== undefined && this.getIsForNewBriefing === true) {
                  return;
                }

                // const isForReportDetail = this.getIsShowEditReportRef && this.getSelectedResource;
                const isForBriefingDetail = this.$route.name === 'MyBriefing-Detail' && this.getSelectedBriefingPage?.bpId;
                // const isForBriefingDetail =
                //   this.$route.name === 'MyBriefing-Detail' &&
                //   this.getSelectedBriefingPage?.bpId &&
                //   (this.getIsForNewBriefing === undefined || !this.getIsForNewBriefing);

                if (isForBriefingDetail && !isForReportDetail && !this.getIsOpenPopupEditReferenceForPage) {
                  // reSave documents with bpId

                  tempDocuments = tempDocuments.filter(td => this.documentsHaveContentList.includes(td.parentDocId));

                  if (tempDocuments && tempDocuments.length > 0) {
                    await this.briefingService()
                      .saveBriefingResource(
                        tempDocuments.map(item => ({
                          ...item,
                          requestId: tempRequestId,
                          requestedResourceList: requestedResourceList,
                          targetBpId: (this.$route.name === 'MyBriefing-Detail' && this.getSelectedBriefingPage?.bpId) || item.targetBpId,
                        })),
                        true
                      )
                      .then(async secondResponse => {
                        if (secondResponse?.status === 200 && secondResponse?.data?.body?.data) {
                          documentSaveSuccess = documentSaveSuccess.filter(
                            doss => secondResponse.data.body?.data?.map(data => data.parentDocId).indexOf(doss.parentDocId) > -1
                          );
                        } else {
                          this.$bvToast.toast(`${this.$t('toast.saveReferenceFail')}`, {
                            toaster: 'b-toaster-bottom-right',
                            title: `${this.$t('toast.title.error')}`,
                            variant: 'danger',
                            solid: true,
                            autoHideDelay: 5000,
                          });

                          this.isLoading = false;
                          this.resetCheckCrawData();

                          return;
                        }
                      })
                      .catch(error => {
                        console.log('Error save resource: ', error);
                        this.$bvToast.toast(`${this.$t('toast.saveReferenceFail')}`, {
                          toaster: 'b-toaster-bottom-right',
                          title: `${this.$t('toast.title.error')}`,
                          variant: 'danger',
                          solid: true,
                          autoHideDelay: 5000,
                        });

                        this.isLoading = false;
                        this.resetCheckCrawData();

                        return;
                      });
                  }
                }
              })
              .catch(error => {
                console.log('Error send document to converter: ', error);
                this.$bvToast.toast(`${this.$t('toast.saveReferenceFail')}`, {
                  toaster: 'b-toaster-bottom-right',
                  title: `${this.$t('toast.title.error')}`,
                  variant: 'danger',
                  solid: true,
                  autoHideDelay: 5000,
                });

                this.isLoading = false;
                this.resetCheckCrawData();

                return;
              });

            if (this.isCancelCrawData === true) {
              this.documentsHaveContentList = [];
              return;
            }

            documentSaveSuccess.forEach(document => {
              lastIndex++;
              document['referenceDocumentIndex'] = lastIndex;
            });
            let tempMergeArray = mergeTwoArrayByRemoveAllDuplicatedItemByDocIdAndPath(this.getReferenceDocuments, [
              ...documentSaveSuccess.map(doc => convertToBriefingReferenceItemRefactor(doc, true)),
            ]);

            // tempMergeArray.forEach((item, index) => {
            //   console.log(item);
            // });

            if (!isForReportDetail) {
              // if (this.getIsOpenPopupEditReferenceForPage) {
              if (
                this.getIsOpenPopupEditReferenceForPage &&
                (this.getIsForNewBriefing === undefined || this.getIsForNewBriefing === false)
              ) {
                tempMergeArray = [...documentSaveSuccess.map(doc => convertToBriefingReferenceItemRefactor(doc, true))];

                if (tempMergeArray && tempMergeArray.length > 0) {
                  this.setStoreReferencesForEditByPage([...tempMergeArray]);
                }
              } else if (this.getIsForNewBriefing !== undefined && this.getIsForNewBriefing === true) {
                tempMergeArray = [...documentSaveSuccess.map(doc => convertToBriefingReferenceItemRefactor(doc, true))];

                this.setReferenceDocumentsForNewBriefing([...tempMergeArray]);
              } else {
                this.setReferenceDocuments([...tempMergeArray]);
              }
            } else {
              tempMergeArray = [...documentSaveSuccess.map(doc => convertToBriefingReferenceItemRefactor(doc, true))];

              if (tempMergeArray && tempMergeArray.length > 0) {
                this.setReferenceDocumentsForReport([...tempMergeArray]);
              }
            }

            this.resetAddingReferenceDocuments();
            // this.documentsHaveContentList = [];
            // this.setShowAddReference(false);
          } else {
            this.$bvToast.toast(`${this.$t('toast.saveReferenceFail')}`, {
              toaster: 'b-toaster-bottom-right',
              title: `${this.$t('toast.title.error')}`,
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
            });

            this.resetCheckCrawData();
          }
        });
    }
  }

  async tryAddToReferenceDocuments() {
    this.disableButtons();
    this.resetCheckCrawData();

    this.isLoadingCheckCrawData = true;

    try {
      // throw new Error();
      await this.addToReferenceDocuments().then(() => {
        this.undisableButtons();
        this.showResultCheckCrawData();
      });
    } catch (e) {
      this.$bvToast.toast(`${this.$t('toast.saveReferenceFail')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('toast.title.error')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
      this.isLoading = false;
      this.resetCheckCrawData();
    } finally {
      this.undisableButtons();
      // this.showResultCheckCrawData();
    }
  }

  disableButtons() {
    this.isLoading = true;
    this.setDisabledLink(true);
    setTimeout(() => {
      this.setDisabledLink(false);
    }, 5000);
  }

  undisableButtons() {
    this.isLoading = false;
    this.setDisabledLink(false);
  }

  async waitCrawData(idsInput: string[], isContinue: boolean): Promise<void> {
    if (this.isCancelCrawData === true || !idsInput) {
      this.showResultCheckCrawData();
      this.clearTimeoutShowCheckCrawData();
      clearInterval(this.intervalWaitCrawData);
      this.intervalWaitCrawData = null;
      this.isLoading = false;
      this.documentsHaveContentList = [];

      return;
    }

    clearInterval(this.intervalWaitCrawData);
    this.clearTimeoutShowCheckCrawData();
    this.intervalWaitCrawData = null;
    // this.isShowResultCheckCrawData = false;
    this.documentsHaveContentList = [];
    // this.isCancelCrawData = false;
    // this.idsListDocumentCheckCrawData = [];

    return new Promise<void>((resolve, reject) => {
      const fetchData = async (): Promise<void> => {
        try {
          // throw new Error();
          if (this.isCancelCrawData === false) {
            const response = await this.briefingService().callApiCheckCrawDataProcess(idsInput);
            if (response?.data?.body?.data && response?.data?.body?.data.length > 0) {
              this.documentsHaveContentList = response?.data?.body?.data;

              if (idsInput.length === response?.data?.body?.data?.length) {
                this.documentsHaveContentList = idsInput?.filter(item => response?.data?.body?.data?.includes(item));
                clearInterval(this.intervalWaitCrawData);
                this.intervalWaitCrawData = null;

                if (isContinue === false || !isContinue) {
                  this.showResultCheckCrawData();
                }

                resolve();
              }
            }
          } else {
            this.showResultCheckCrawData();
            this.clearTimeoutShowCheckCrawData();
            clearInterval(this.intervalWaitCrawData);
            this.intervalWaitCrawData = null;
            this.isLoading = false;
          }
        } catch (error) {
          console.log('Error while checking craw data process:', error);
          this.$bvToast.toast(`${this.$t('toast.saveReferenceFail')}`, {
            toaster: 'b-toaster-bottom-right',
            title: `${this.$t('toast.title.error')}`,
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
          // this.showResultCheckCrawData();
          this.clearTimeoutShowCheckCrawData();
          clearInterval(this.intervalWaitCrawData);
          this.intervalWaitCrawData = null;
          this.isLoadingCheckCrawData = false;
          this.isLoading = false;
        }
      };

      this.intervalWaitCrawData = setInterval(fetchData, this.pollingIntervalCheckCrawData);

      this.timeoutShowResultCheckCrawData = setTimeout(() => {
        this.clearTimeoutShowCheckCrawData();
        clearInterval(this.intervalWaitCrawData);
        this.intervalWaitCrawData = null;

        if (isContinue === false || !isContinue) {
          this.showResultCheckCrawData();
        }

        resolve();
      }, this.timeoutDurationCheckCrawData);

      fetchData();
    });
  }

  async saveFileForDocumentConverter(
    saveFile: boolean,
    tempDocumentsFile: any[],
    requestId: string | any,
    tempRequestResourceListFile: any[],
    userKey: string | any,
    localFilesWithS3: any[],
    driveFilesWithS3: any[],
    fileFormData: FormData | any
  ) {
    if (saveFile && tempDocumentsFile && tempDocumentsFile.length > 0) {
      const language = this.$i18n.locale;
      const mapKeyValue = new Map();
      mapKeyValue.set('forcedClustering', false);
      mapKeyValue.set('requestId', requestId);
      mapKeyValue.set(
        'requestedScrapList',
        tempRequestResourceListFile.filter((item, index) => tempRequestResourceListFile.indexOf(item) === index)
      );

      try {
        const response = await axios.post(
          `api/learning/learning-center/savefile/${userKey}?`
            .concat('forcedClustering=' + 'false')
            .concat('&requestId=' + requestId)
            .concat('&requestedScrapList=' + tempRequestResourceListFile.join(','))
            .concat(language ? '&lang=' + language : '&lang=en')
            .concat(localFilesWithS3 ? '&localFilesWithS3Json=' + encodeURIComponent(JSON.stringify(localFilesWithS3)) : '')
            .concat(driveFilesWithS3 ? '&driveFilesWithS3Json=' + encodeURIComponent(JSON.stringify(driveFilesWithS3)) : ''),
          fileFormData
        );

        return response;
      } catch (error) {
        console.error('Error saving file for document converter:', error);
      }
    }
  }

  resetCheckCrawData() {
    this.clearTimeoutShowCheckCrawData();
    clearInterval(this.intervalWaitCrawData);
    this.intervalWaitCrawData = null;
    this.isLoadingCheckCrawData = false;
    this.isShowResultCheckCrawData = false;
    this.documentsHaveContentList = [];
    this.isCancelCrawData = false;
    // this.idsListDocumentCheckCrawData = [];
    this.numberTotalDocumentsCheckCrawData = 0;
  }

  showResultCheckCrawData() {
    this.isShowResultCheckCrawData = true;
  }

  handleClickCancelCrawData() {
    this.isCancelCrawData = true;
    this.clearTimeoutShowCheckCrawData();
    this.waitCrawData(null, false);
  }

  clearTimeoutShowCheckCrawData() {
    if (this.timeoutShowResultCheckCrawData !== null) {
      clearTimeout(this.timeoutShowResultCheckCrawData);
      this.timeoutShowResultCheckCrawData = null;
    }
  }
}
